export const connectivityTypes = {
  SIGFOX: 'Sigfox',
  LORA: 'LoRaWAN',
  GSM: 'GSM',
  WIFI: 'Wi-Fi',
  CMNB: 'Cellular IoT',
  ETH: 'Ethernet',
  UNKNOWN: 'UNKNOWN'
}

export const getConnectivity = micaModel => {
  if (micaModel.indexOf('SGFX') > -1) {
    return connectivityTypes.SIGFOX
  } else if (micaModel.indexOf('LORA') > -1) {
    return connectivityTypes.LORA
  } else if (micaModel.indexOf('TSIM') > -1 || micaModel.indexOf('GSM') > -1) {
    return connectivityTypes.GSM
  } else if (micaModel.indexOf('CMNB') > -1) {
    return connectivityTypes.CMNB
  } else if (micaModel.indexOf('ETH') > -1) {
    // EL CONNECTIVITY MODE ES ETH0 Y EL MODEL ES ETH
    return connectivityTypes.ETH
  } else if (micaModel.indexOf('WIFI') > -1) {
    return connectivityTypes.WIFI
  }
  return connectivityTypes.UNKNOWN
}
